import React from "react";

const Intro = () => {
  return (
    <div id="token">
      <div className="features intro pt-5 pb-5" style={{ overflow: "hidden" }}>
        <h2 className="px-3" data-aos="zoom-in"
     data-aos-duration="1000">
          Introducing the <br />{" "}
          <span style={{ color: "#ed0101" }}> PHARMA Token</span>
        </h2>
        <p data-aos="zoom-in"
     data-aos-duration="1100" className="px-3" style={{ textWrap: "balance" }}>
          PHARMA is the native utility token of the Pharma Trades platform. It
          is used for paying fees, <br /> earning referral rewards, and
          participating in governance.
        </p>
        <div className="container">
          <div className="row pt-5 pb-5">
            <div
              className="col-lg-4 mb-4"
              data-aos="fade-up"
              data-aos-duration="1000"
            >
              <div className="cards">
                <div className="text-center mb-4">
                  <img src="/assets/images/card-8.svg" alt="card-1" />
                </div>
                <h3 className="mb-4">Fee Payments</h3>
                <p>
                  All initiation fees (1% of the trade value) are paid in PHARMA
                  tokens.
                </p>
              </div>
            </div>
            <div
              className="col-lg-4 mb-4"
              data-aos="fade-up"
              data-aos-duration="1000"
            >
              <div className="cards">
                <div className="text-center mb-4">
                  <img src="/assets/images/card-9.svg" alt="card-1" />
                </div>
                <h3 className="mb-4">Referral Rewards</h3>
                <p>
                  Earned and paid out in PHARMA, incentivizing community growth.
                </p>
              </div>
            </div>
            <div
              className="col-lg-4 mb-4"
              data-aos="fade-up"
              data-aos-duration="1000"
            >
              <div className="cards">
                <div className="text-center mb-4">
                  <img src="/assets/images/card-10.svg" alt="card-1" />
                </div>
                <h3 className="mb-4">Governance Participation</h3>
                <p>
                  Token holders can vote on platform decisions and future
                  developments
                </p>
                <div className="text-center pt-4">
                  <span>COMING SOON</span>
                </div>
              </div>
            </div>
          </div>
          {/* <div className="row token">
            <h3 className="mb-4">Token Metrics</h3>
            <div
              className="col-lg-3 d-flex flex-column align-items-center justify-content-center"
              data-aos="fade-up"
              data-aos-duration="1000"
            >
              <h2 className="text-center">20m+</h2>
              <p className="text-start">Total Supply</p>
            </div>
            <div
              className="col-lg-3 d-flex flex-column align-items-center justify-content-center"
              data-aos="fade-up"
              data-aos-duration="1000"
            >
              <h2 className="text-center">56.6%</h2>
              <p className="text-start">PT Token</p>
            </div>
            <div
              className="col-lg-3 d-flex flex-column align-items-center justify-content-center"
              data-aos="fade-up"
              data-aos-duration="1000"
            >
              <h2 className="text-center">24.5%</h2>
              <p className="text-start">Trade Token</p>
            </div>
            <div
              className="col-lg-3 d-flex flex-column align-items-center justify-content-center"
              data-aos="fade-up"
              data-aos-duration="1000"
            >
              <h2 className="text-center">26.5%</h2>
              <p className="text-start">Community Token</p>
            </div>
          </div> */}
        </div>
      </div>
    </div>
  );
};

export default Intro;
